import { listBrandKit, BrandKit } from '@goldcast/api/backend';
import logger from '@goldcast/logger';

const actions = {
  async fetchBrandKits({ commit, state, rootGetters }): Promise<void> {
    const currentOrg = rootGetters['org/getCurrentOrg'];
    if (!currentOrg?.useAIPageRevamp) {
      return;
    }

    if (state.isLoading) {
      return;
    }

    try {
      commit('setIsLoading', true);
      const response = await listBrandKit({ queryParams: {} });
      const brandKits = (response as BrandKit[]) || [];
      commit('setBrandKits', brandKits);
      commit('setIsLoaded', true);
    } catch (error) {
      logger.error('Error fetching brand kits:', error);
      commit('setIsLoaded', false);
    } finally {
      commit('setIsLoading', false);
    }
  },

  async ensureBrandKitsLoaded({ dispatch, state }): Promise<void> {
    if (state.isLoaded) {
      return;
    }

    await dispatch('fetchBrandKits');
  }
};

export default actions;
